var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eco-content-space h100 overflow-y-auto"},[_c('div',{staticClass:"white-box"},[_c('client-stats')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }